import React, { useState } from "react";
import "./products-searchbar.css";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import { FaSearch } from "react-icons/fa";
import useProductStore from "../../Stores/productStore";
import useFilterStore from "../../Stores/filterStore";
import { useEffect } from "react";

function ProductsSearchbarComponent() {
  const [searchBar, setSearchBar] = useState("");
  const setProductList = useProductStore((state) => state.replaceProducts);
  const filters = useFilterStore((state) => state.filters);
  const replaceFilters = useFilterStore((state) => state.replaceFilters);

  const searchByName = () => {
    // fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/products?name=" + searchBar)
    //   .then((data) => data.json())
    //   .then((res) => {
    //     console.log(res);
    //     setProductList([...res]);
    //   });
    replaceFilters({...filters, name: {$regex: searchBar, $options: 'i'}})
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    const searchValue = urlParams.get('search')
    if(searchValue){
      setSearchBar(searchValue)
      searchByName()
    }
  }, [])

  return (
    <div className="searchbar-container">
      <Paper
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            searchByName();
          }
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Buscar Productos"
          inputProps={{ "aria-label": "buscar productos" }}
          value={searchBar}
          onChange={(e) => setSearchBar(e.target.value)}
        />
        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
        <IconButton
          color="gray"
          sx={{ p: "10px" }}
          aria-label="directions"
          onClick={searchByName}
        >
          {/* <DirectionsIcon /> */}
          <FaSearch />
        </IconButton>
      </Paper>
    </div>
  );
}

export default ProductsSearchbarComponent;
